<template>
  <div>
    <my-asidebar v-bind:active-tab="'agency-proforma'"> </my-asidebar>

    <section class="dashboard-area">
      <top-bar></top-bar>
      <div class="dashboard-content-wrap">
        <div class="dashboard-bread dashboard--bread dashboard-bread-2">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="breadcrumb-content">
                  <div class="section-heading">
                    <h2 class="sec__title font-size-30 text-white">Acente Proforma</h2>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="breadcrumb-list text-right">
                  <ul class="list-items">
                    <li><a :href="basePath" class="text-white">Anasayfa</a></li>
                    <li>Acente Proforma</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <agency-proforma-list/>
      </div>
    </section>

  </div>
</template>

<script>
import TopBar from "../component/common/TopBar";
import MyAsidebar from "../component/common/MyAsidebar";
import AgencyProformaList from "../component/agency/AgencyProformaList";

export default {
  name: "ProformaListPage",
  components: {
    AgencyProformaList, MyAsidebar, TopBar},
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    panelRights: {
      get() {
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  mounted() {
    if(!this.panelRights["PANEL_PAGE_PROFORMA_LIST"]) this.$router.push("/");
    this.$store.dispatch("loadAgencyProformas");
    this.$store.dispatch("loadAgencyList");
    if(this.panelRights["PANEL_PAGE_PROFORMA_LIST_ALL"]){
      this.$store.dispatch("loadSailsLiteAll");
    }else{
      this.$store.dispatch("loadSailsLite");
    }
  }
}
</script>

<style scoped>

</style>